import { render, staticRenderFns } from "./UniversityExamUpdateCourseCoScore.vue?vue&type=template&id=24fead7d"
import script from "./UniversityExamUpdateCourseCoScore.vue?vue&type=script&lang=js"
export * from "./UniversityExamUpdateCourseCoScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports